import http from "@/utils/http";


export const PassageRecordLogApi = {
	page(query) {
		return http.get(`/nexus/acsPassageRecordLog/page`,query)
	},
}